<template>
  <v-table
      :count="count"
      :list="list"
      :query-list="queryList"
      :is-loading="isLoading"
      :push-list="RouteConfig.administratorLoginRecordList.push"
      :is-show-store-select="true"
      :has-private-store="true"
      :is-store-select-clearable="true"
      :is-show-search-input="true"
  >
    <v-column-time value="登录时间"/>
    <el-table-column label="登录日志ID" prop="id" width="100px"/>
    <v-column-admin label="登录人"/>
    <el-table-column label="登录门店">
      <template v-slot="{ row }">{{ row.store_name | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="登录角色" prop="role"/>
    <el-table-column label="登录职位" prop="role_name"/>
    <el-table-column label="登录 IP" prop="ip"/>
    <el-table-column label="浏览器信息" prop="user_agent"/>
    <el-table-column label="登录凭证" prop="token"/>
    <v-column-time value="凭证过期时间" field="expire_time" sortable=""/>
    <el-table-column label="用户名" prop="username"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="企业微信码" prop="we_chat_code"/>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`login-record-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>登录时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>登录日志ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>登录人</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>登录门店</span>
              <span>{{ v.store_name | formatStoreName }}</span>
            </div>

            <div class="list-item-detail">
              <span>登录角色</span>
              <span>{{ v.role }}</span>
            </div>

            <div class="list-item-detail">
              <span>登录职位</span>
              <span>{{ v.role_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>登录 IP</span>
              <span>{{ v.ip }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">浏览器信息</span>
              <span class="text-right">{{ v.user_agent }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">登录凭证</span>
              <span class="list-item-info">{{ v.token }}</span>
            </div>

            <div class="list-item-detail">
              <span>凭证过期时间</span>
              <span>{{ v.expire_time }}</span>
            </div>

            <div class="list-item-detail">
              <span>用户名</span>
              <span>{{ v.username }}</span>
            </div>

            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>

            <div class="list-item-detail">
              <span>企业微信码</span>
              <span>{{ v.we_chat_code }}</span>
            </div>

            <div class="list-item-button"></div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getLoginRecords } from '@/api/administrator';

export default {
  name: RouteConfig.administratorLoginRecordList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getLoginRecords(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
  },
};
</script>
